import axios from 'axios'

export const api = axios.create({
  baseURL: 'https://admancriativa.com.br/teste/api',
})
